"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _AnchorTag = _interopRequireDefault(require("../utils/AnchorTag"));
var _ButtonAnchor = _interopRequireDefault(require("../utils/ButtonAnchor"));
var _ResponsiveImage = _interopRequireDefault(require("../utils/ResponsiveImage"));
var _helpers = require("../../utils/helpers");
const ImageCardCore = /*#__PURE__*/(0, _react.forwardRef)(function ImageCardCore({
  image = {
    url: '',
    altText: '',
    aspectRatio: 1,
    sources: []
  },
  mobileImage = {
    url: '',
    altText: '',
    aspectRatio: 1
  },
  fullSizeImagePosition = [50, 50],
  mobileImagePosition = [50, 50],
  lazyLoad = true,
  fetchPriority = null,
  decoding = 'async',
  title = '',
  content = ``,
  clampContentLines = true,
  numberOfLinesToClamp = 3,
  overlayContent = ``,
  overlayPosition = `left`,
  overlayTextColor = `#fff`,
  relatedResourceId = ``,
  cta = {
    label: '',
    href: '',
    type: '',
    relatedResourceId: '',
    position: 'end'
  },
  displayCTA = true,
  handleClicks = () => {},
  fullCardClickable = false,
  displayInline = false,
  classname = '',
  styles = {}
}, ref) {
  var _ctaDataMap$get;
  const ctaDataMap = new Map([['play-video', {
    label: `View Promo`,
    component: _ButtonAnchor.default
  }], ['internal-link', {
    label: `View More`,
    component: _AnchorTag.default
  }], ['external-link', {
    label: `Learn More`,
    component: _AnchorTag.default
  }], ['info-panel', {
    label: `View More`,
    component: _ButtonAnchor.default
  }], ['show-modal', {
    label: `See More`,
    component: _ButtonAnchor.default
  }]]);
  const CTAButton = (_ctaDataMap$get = ctaDataMap.get(cta.type)) === null || _ctaDataMap$get === void 0 ? void 0 : _ctaDataMap$get.component;
  const renderCTAButton = cta => /*#__PURE__*/_react.default.createElement(CTAButton, {
    classname: (0, _helpers.classes)([styles['image-card__cta'], 'image-card__cta']),
    href: cta.href,
    label: cta.label ? cta.label : ctaDataMap.get(cta.type).label
    /* if cta is a link skip click handler */,
    onClick: cta.type !== 'internal-link' && cta.type !== 'external-link' ? handleCTAClick : () => true,
    "data-resource-id": cta.relatedResourceId,
    type: cta.type
  });
  const handleCTAClick = e => {
    e.stopPropagation();
    handleClicks({
      type: cta.type,
      resourceId: cta.relatedResourceId,
      resourceType: cta.relatedResourceType,
      target: e.target,
      currentTarget: e.currentTarget
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([styles['image-card__img-wrapper'], 'image-card__img-wrapper'])
  }, mobileImage.url !== '' && /*#__PURE__*/_react.default.createElement("img", {
    className: styles['image-card__mobile-image'],
    src: mobileImage.url,
    alt: mobileImage.altText,
    onClick: (cta.type === 'play-video' || cta.type === 'show-modal') && !fullCardClickable ? handleCTAClick : () => true,
    loading: lazyLoad ? 'lazy' : null,
    fetchpriority: fetchPriority,
    decoding: decoding
  }), /*#__PURE__*/_react.default.createElement(_ResponsiveImage.default, {
    classname: styles['image-card__image'],
    sources: image.sources,
    fullSizeUrl: image.url,
    altText: image.altText,
    loading: lazyLoad ? 'lazy' : null,
    fetchpriority: fetchPriority,
    decoding: decoding,
    handleClick: (cta.type === 'play-video' || cta.type === 'show-modal') && !fullCardClickable ? handleCTAClick : () => true
  }), overlayContent !== '' && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([styles['image-card__overlay-content'], 'image-card__overlay-content'])
  }, typeof overlayContent === "string" ? (0, _htmlReactParser.default)(overlayContent) : overlayContent), (cta === null || cta === void 0 ? void 0 : cta.type) === 'play-video' && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: handleCTAClick,
    className: (0, _helpers.classes)([styles['image-card__play-icon'], 'image-card__play-icon'])
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "PLAY BUTTON"), /*#__PURE__*/_react.default.createElement("div", {
    className: `${styles['play-icon__triangle']}`
  }))), content !== '' && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([styles['image-card__content'], 'image-card__content'])
  }, title !== '' && /*#__PURE__*/_react.default.createElement("h2", {
    className: "h4"
  }, title), typeof content === "string" && /*#__PURE__*/_react.default.createElement("div", null, (0, _htmlReactParser.default)(content), displayCTA && (cta === null || cta === void 0 ? void 0 : cta.type) && cta.position === 'inline' && renderCTAButton(cta)), typeof content !== "string" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, content, displayCTA && (cta === null || cta === void 0 ? void 0 : cta.type) && cta.position === 'inline' && renderCTAButton(cta))), displayCTA && (cta === null || cta === void 0 ? void 0 : cta.type) && (cta === null || cta === void 0 ? void 0 : cta.position) === 'end' && /*#__PURE__*/_react.default.createElement("div", {
    className: styles['image-card__cta-wrapper']
  }, renderCTAButton(cta)));
});
var _default = exports.default = ImageCardCore;